import { type NexusApiActionDef } from "./action-def.types";
import { bool, num, obj, str } from "./output-format.builders";

export const workspaceActions: NexusApiActionDef[] = [
  {
    action: "workspace.write",
    label: "Write File",
    description:
      "Write (or append to) a file in a workspace — the no-code equivalent of a WebDAV PUT. Drops content into a path like `inbox/meetings/2026-06-07-standup.vtt` with org-scoped auth and validated inputs.",
    inputSchema: {
      workspaceSlug: {
        type: "string",
        description: "Workspace identifier (slug), e.g. `company-general-context`"
      },
      path: {
        type: "string",
        description:
          "File path within the workspace, relative to its root (no leading slash), e.g. `inbox/meetings/2026-06-07-standup.vtt`"
      },
      content: {
        type: "string",
        description: "File content. UTF-8 text by default; set encoding to `base64` for binary."
      },
      encoding: {
        type: "string",
        description: "How `content` is encoded (optional, default `utf-8`)",
        constraints: {
          allowedValues: ["utf-8", "base64"],
          allowedOptions: [
            { label: "UTF-8 text", value: "utf-8" },
            { label: "Base64 (binary)", value: "base64" }
          ]
        }
      },
      contentType: {
        type: "string",
        description: "MIME type to store (optional, default `text/markdown`)"
      },
      mode: {
        type: "string",
        description:
          "`write` overwrites the file; `append` reads existing content and concatenates (optional, default `write`)",
        constraints: {
          allowedValues: ["write", "append"],
          allowedOptions: [
            { label: "Write (overwrite)", value: "write" },
            { label: "Append", value: "append" }
          ]
        }
      },
      createParents: {
        type: "boolean",
        description: "Auto-create missing parent folders, like `mkdir -p` (optional, default true)"
      }
    },
    outputFormat: obj("Result", {
      success: bool("Whether the write succeeded"),
      path: str("The path the file was written to"),
      bytesWritten: num("Total bytes persisted"),
      sha256: str("SHA-256 of the persisted bytes (hex)")
    })
  }
];
